import {
	createStyles,
	Fade,
	Grid,
	Paper,
	Snackbar,
	SnackbarContent,
	Theme,
	Typography,
	WithStyles,
	withStyles,
} from '@material-ui/core'
import { green } from '@material-ui/core/colors'
import React from 'react'
import { RouteComponentProps } from 'react-router'

import ParticipantOutcomeFormPicker from '../../Forms/Outcomes/FormItems/ParticipantOutcomeFormPicker'
import { getActivityById, getParticipantInfoById } from '../../services/enrollment.service'
import { ParticipantOutcome } from '../../services/Model/Outcome'
import { getParticipantOutcomes, updateParticipantOutcomes, uploadDocument } from '../../services/outcomes.service'
import DefaultLoaderModal from '../DefaultLoaderModal/DefaultLoaderModal'
import {updateCredentialDoc, resetState, genericAction, updateDateCredentailAttained, setPK} from '../../features/pacticipantOutcomeSlice'
import {connect,ConnectedProps} from 'react-redux'
import { encryptPayload } from 'src/services/utils'
import { authorizationCheck } from 'src/services/auth.service'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { mockActivities } from '../../services/enrollment.service'
import moment from 'moment'
import { State_City_Zip_Mapper, StateIDs } from 'src/services/Model/Participant'
import { getEmployers } from '../../services/outcomes.service'


const { REACT_APP_EM_API_URL } = process.env

const mapStateToProps = (state:any) => ({
  credentialDoc: state.participantOutcome.credentialDoc,
  credentialDoc1: state.participantOutcome.credentialDoc1,
  credentialDoc1FileName: state.participantOutcome.credentialDoc1FileName,
  credentialDoc1FileExt: state.participantOutcome.credentialDoc1FileExt,
  credentialDoc2: state.participantOutcome.credentialDoc2,
  credentialDoc2FileName: state.participantOutcome.credentialDoc2FileName,
  credentialDoc2FileExt: state.participantOutcome.credentialDoc2FileExt,
  pk: state.participantOutcome.pk,
  dateCredentialAttained:state.participantOutcome.dateCredentialAttained,
  // measurableSkillGain: state.participantOutcome.measurableSkillGain,
  // dateSkillAttained:state.participantOutcome.dateSkillAttained,
  credential1:state.participantOutcome.credential1,
  credential2:state.participantOutcome.credential2,
  credentialType:state.participantOutcome.credentialType,
  credentialType2:state.participantOutcome.credentialType2,
  dateCredentialAttained1:state.participantOutcome.dateCredentialAttained1,
  dateCredentialAttained2:state.participantOutcome.dateCredentialAttained2,
  siteCode: state.participantOutcome.siteCode,
  internshipEmployer: state.participantOutcome.internshipEmployer,
  jobPlacementEmployer: state.participantOutcome.jobPlacementEmployer,
  incumbentEmployer: state.participantOutcome.incumbentEmployer,
  employers: state.participantOutcome.employers,
  existing_jobPlacementEmployer: state.participantOutcome.existing_jobPlacementEmployer,
  selectedEmployerId: state.participantOutcome.selectedEmployerId,
});

const mapDispatchToProps = { updateCredentialDoc, resetState, genericAction, updateDateCredentailAttained, setPK };

const connector = connect(
  mapStateToProps,
  mapDispatchToProps
)

type PropsFromRedux = ConnectedProps<typeof connector>


interface ParticipantOutcomesLandingProps extends WithStyles<typeof styles>, PropsFromRedux {}

export type RouterProps = ParticipantOutcomesLandingProps &
	RouteComponentProps<{
		activityID: string
		participantID: string
	}>

export const ParticipantOutcomesLanding: React.FC<RouterProps> = (props: RouterProps) => {
  console.log(`ParticipantOutcomesLanding rendered`)
	const { classes, match, dateCredentialAttained,jobPlacementEmployer, employers, incumbentEmployer,internshipEmployer, existing_jobPlacementEmployer, selectedEmployerId } = props
	const location: any = props.location;
	const { activityID, participantID } = match.params
	const participantName = location.state && location.state.participantName ? location.state.participantName : ''

	const [loading, setLoading] = React.useState(true)
	const [loadingData, setLoadingData] = React.useState(true)
	const [snackbar, setSnackbar] = React.useState({
		open: false,
		message: 'Record Updated Successfully',
		type: 'success',
	})
	const [outcomes, setOutcomes] = React.useState<any>()
	const [outcomesCopy, setOutcomesCopy] = React.useState<any>()
	const [currentActivity, setCurrentActivity] = React.useState()
	const [participant, setParticipant] = React.useState(null)
  // const [employers, setEmployers] = React.useState([])
  let errors = []

	const handleApiResponse = (status: 'error' | 'success', snackAlert?: boolean, message?:string): any => {
		const snackBarStatus =
			status === 'success'
				? { open: true, type: 'success', message: 'Outcomes updated' }
				: { open: true, type: 'error', message: 'Something went wrong' }

    if(message){
      snackBarStatus.message = message
    }

		setLoadingData(false)
		setLoading(false)
		if (snackAlert) setSnackbar(snackBarStatus)
	}

  const setStateProperties = (o: ParticipantOutcome)=>{
    const payload = {
      credential1:o.credential1,
      credential2:o.credential2,
      credentialType:o.credentialType,
      credentialType2:o.credentialType2,
      dateCredentialAttained1:o.dateCredentialAttained1?new Date(o.dateCredentialAttained1).toISOString().slice(0,10).replace(/-/g,"-"):null,
      dateCredentialAttained2:o.dateCredentialAttained2?new Date(o.dateCredentialAttained2).toISOString().slice(0,10).replace(/-/g,"-"):null,
      credentialDoc1:null,
      credentialDoc2:null,
      credentialDoc1Uploaded: o.credentialDoc1Uploaded,
      credentialDoc2Uploaded: o.credentialDoc2Uploaded,
      external_id: o.external_id,
      existing_dateCredentialAttained1:o.dateCredentialAttained1?new Date(o.dateCredentialAttained1).toISOString().slice(0,10).replace(/-/g,"-"):null,
      existing_dateCredentialAttained2:o.dateCredentialAttained2?new Date(o.dateCredentialAttained2).toISOString().slice(0,10).replace(/-/g,"-"):null,
      existing_credentialType: o.credentialType,
      existing_credentialType2: o.credentialType2,
      existing_credential1: o.credential1,
      existing_credential2: o.credential2,
      internshipEmployer: o.internshipEmployer,
      existing_internshipEmployer: o.internshipEmployer,
      jobPlacementEmployer: o.jobPlacementEmployer,
      existing_jobPlacementEmployer: o.jobPlacementEmployer,
      incumbentEmployer: o.incumbentEmployer,
      existing_incumbentEmployer: o.incumbentEmployer,
    }
    debugger
    props.genericAction(payload)
  }

  React.useEffect(()=>{
    let o = outcomes
    let jobPlacementEmployerAddress1 = outcomes?.jobPlacementEmployerAddress1
    let jobPlacementEmployerZipcode = outcomes?.jobPlacementEmployerZipcode?.trim()
    let jobPlacementEmployerCity = outcomes?.jobPlacementEmployerCity
    let jobPlacementEmployerState = outcomes?.jobPlacementEmployerState
    let state_city_zip_obj
    console.log(`ParticipantsOutcomesLanding selectedEmployerId = ${selectedEmployerId}`)
    if(employers){
      console.log(`Employers: ${JSON.stringify(employers,undefined,2)}`)
    }

    // Address auto fill feature
    /* if(jobPlacementEmployer && jobPlacementEmployer.length>0 && jobPlacementEmployer !== existing_jobPlacementEmployer && selectedEmployerId){
      debugger
      // const employer = employers.find(e=>e.employer_name?.toLowerCase()?.trim() === jobPlacementEmployer?.toLowerCase()?.trim())
      const employer = employers.find(e=>e.id === selectedEmployerId)
      console.log(`Employer: ${JSON.stringify(employer,undefined,2)}`)
      if(employer){
        if(employer?.state?.toLowerCase() === 'ri'){
          if(employer.zip_code?.length>0 && employer.city?.length>0){
            state_city_zip_obj = State_City_Zip_Mapper.find(ele=>ele?.zip?.trim() == employer.zip_code?.trim() && ele?.city?.toLowerCase()?.trim() == employer.city?.toLowerCase()?.trim())
            if(state_city_zip_obj){
              jobPlacementEmployerState = 'RI'
              jobPlacementEmployerAddress1 =employer.street || jobPlacementEmployerAddress1
              jobPlacementEmployerCity =  state_city_zip_obj.city || jobPlacementEmployerCity
              jobPlacementEmployerZipcode = state_city_zip_obj.zip || jobPlacementEmployerZipcode
            }
          }
        }
        debugger
        if(!state_city_zip_obj){
          if(employer?.state?.trim()?.toLowerCase() === 'ri'){
            State_City_Zip_Mapper.push({
              city:employer.city,
              state: employer.state,
              zip: employer.zip_code
            })
          }
          jobPlacementEmployerState =  employer?.state?.toUpperCase() || outcomes?.jobPlacementEmployerState
          jobPlacementEmployerAddress1 = employer.street || jobPlacementEmployerAddress1
          jobPlacementEmployerCity = employer.city || jobPlacementEmployerCity
          jobPlacementEmployerZipcode = employer.zip_code || jobPlacementEmployerZipcode
        }
        setTimeout(()=>{
          setOutcomes((prevOutcome)=>{
            console.log(prevOutcome)
            console.log(`selectedEmployerId jobPlacementEmployerAddress1=${jobPlacementEmployerAddress1}`)
            console.log(`selectedEmployerId jobPlacementEmployerCity=${jobPlacementEmployerCity}`)
            return {...prevOutcome, placedJob:true, jobPlacementEmployerAddress1, jobPlacementEmployerCity, jobPlacementEmployerZipcode, jobPlacementEmployerState}
          })
          // setOutcomesCopy((prevOutcome)=>{
          //   return {...prevOutcome, placedJob:true, jobPlacementEmployerAddress1, jobPlacementEmployerCity, jobPlacementEmployerZipcode, jobPlacementEmployerState}
          // })

          // setTimeout(()=>{
          //   setOutcomes((prevOutcome)=>{
          //     return {...prevOutcome,jobPlacementEmployerZipcode}
          //   })
          // },100)

        },300)
      }
    } */
    if(['ri','RI'].includes(o?.jobPlacementEmployerState?.toString()) || o?.jobPlacementEmployerState?.toString()?.toLowerCase() == 'ri'){
      const state_city_zip_obj = State_City_Zip_Mapper.find(ele=>ele?.zip?.trim() == o.jobPlacementEmployerZipcode?.trim() && ele?.city?.toLowerCase()?.trim() == o.jobPlacementEmployerCity?.toLowerCase()?.trim())
      if(!state_city_zip_obj){
        State_City_Zip_Mapper.push({
          city:o.jobPlacementEmployerCity,
          state: o.jobPlacementEmployerState?.toString(),
          zip: o.jobPlacementEmployerZipcode
        })
      }
    }
    console.log(`jobPlacementEmployer=${jobPlacementEmployer}`)
    const employer = employers.find(e=>e.employer_name === jobPlacementEmployer)
    console.log(`Employer: ${JSON.stringify(employer,undefined,2)}`)
    console.log(`Employers: ${JSON.stringify(employers,undefined,2)}`)
  },[jobPlacementEmployer, employers, selectedEmployerId])

  React.useEffect(()=>{
    setOutcomes((prevOutcome)=>{
      return {
        ...prevOutcome,
        jobPlacementEmployer,
        internshipEmployer,
        incumbentEmployer
      }
    })
    // setOutcomesCopy((prevOutcome)=>{
    //   return {
    //     ...prevOutcome,
    //     jobPlacementEmployer,
    //     internshipEmployer,
    //     incumbentEmployer
    //   }
    // })
  },[jobPlacementEmployer,internshipEmployer,incumbentEmployer])

	React.useEffect(() => {
		getParticipantOutcomes(activityID, participantID)
			.then((o) => {
        debugger
        if(['ri','RI'].includes(o.jobPlacementEmployerState?.toString())){
          const state_city_zip_obj = State_City_Zip_Mapper.find(ele=>ele?.zip?.trim() == o.jobPlacementEmployerZipcode?.trim() && ele?.city?.toLowerCase()?.trim() == o.jobPlacementEmployerCity?.toLowerCase()?.trim())
          if(!state_city_zip_obj){
            State_City_Zip_Mapper.push({
              city:o.jobPlacementEmployerCity,
              state: o.jobPlacementEmployerState?.toString(),
              zip: o.jobPlacementEmployerZipcode
            })
          }
        }
				setOutcomes(getInitialOutcomes(o))
        setOutcomesCopy(getInitialOutcomes(o))
        setStateProperties(o)
				handleApiResponse('success')
        setTimeout(()=>{
          console.log(`document clicked`)
          document.dispatchEvent(new MouseEvent('click', {
                bubbles: false,
                cancelable: true,
                view: window
              }));
      },500)
			})
			.catch(() => {
				handleApiResponse('error')
			})

      getParticipantInfoById(activityID,participantID).then((p)=>{
        setParticipant(p)
      }).catch((e)=>{
        console.error(`Error fetching Participant ${participantID}`)
        setParticipant(null)
      })

      return ()=>{
        props.resetState()
      }

     

	}, [activityID, participantID])

	React.useEffect(() => {
		getActivityById(activityID)
			.then(setCurrentActivity)
			.catch((e) => null)
	}, [activityID])

  React.useEffect(()=>{
    if(!props.pk){
      const getAllEMActivities = async () => {
        if (process.env.NODE_ENV !== 'production') {
          return await {activities:mockActivities, pk:'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlpAYtdoUFl4EVDWsl1fNsXjr96eyneHC6UZcb+wtKEP/L4J/k3Y2qspNdVxrz5+xiR2avvC94wMI1ZdYy4VgBFxQ838lSRQMFO7VlQO/7rklR835JtsRwEzQ1jk2lql323N0GZ/Z5tsigRi1oqTedzDmMWzba1PXszVA4uA6MUzlskCw5mbwxZlBSieDaTat/PR/f40UqZ6HcfZLgsvAl5AB4eHcQ7egui7BesPbWBnfKndhfRFhHtonAGUlXliBXFpFK7MeW55XaudPIJbLO4geEji4Ta2rCgh7CFIAMa6ylCUZwpT0aVohpz47f3vCld23NM9LI91ol5TJrrsvMQIDAQABE'}
        } else {
          try {
            const { data, status } = await axios.get(`${REACT_APP_EM_API_URL}/activities` || '/')
            authorizationCheck(status)
            return data
          } catch (e: any) {
            throw new Error(e)
          }
        }
      }
      getAllEMActivities()
			.then((data)=>{
        if(data.pk){
          props.setPK(data.pk)
        }
        if(data.siteCode){
          props.genericAction({siteCode:data.siteCode})
        }
      })
			.catch((e) => console.error(`Error setting PK ${e.message}`))
    }

    if(!employers || employers.length===0){
      getEmployers().then((employers)=>{
        debugger
        if(employers && employers.length>0){
          props.genericAction({ employers: [...employers] });
        }
      })
      .catch((e)=>{
        console.log(`Error in getEmployers ${e.message}`)
      })
    }
  },[])


  React.useEffect(()=>{
    debugger
    if(['ri','RI'].includes(outcomes?.jobPlacementEmployerState?.toString())){
      const state_city_zip_obj = State_City_Zip_Mapper.find(ele=>ele?.zip?.trim() == outcomes.jobPlacementEmployerZipcode?.trim() && ele?.city?.toLowerCase()?.trim() == outcomes.jobPlacementEmployerCity?.toLowerCase()?.trim())
      if(!state_city_zip_obj){
        State_City_Zip_Mapper.push({
          city:outcomes.jobPlacementEmployerCity,
          state: outcomes.jobPlacementEmployerState?.toString(),
          zip: outcomes.jobPlacementEmployerZipcode
        })
      }
    }
  },[outcomes])

	const getInitialOutcomes = (o: ParticipantOutcome) => {
		const internshipOccupation = o.internshipOccupation || "Unknown"
		const jobPlacementIndustry = o.jobPlacementIndustry || "Unknown"
		const internshipIndustry = o.internshipIndustry || "Unknown"
		const credentialType = o.credentialType || "No recognized credential"
    const credentialType2 = o.credentialType2 || "No recognized credential"
		const wblType = o.wblType || "Unknown"
		const academicCredit = o.academicCredit || "Unknown"
    // const measurableSkillGain = o.measurableSkillGain || "Unknown"
    const credentialDoc1Uploaded = o.credentialDoc1Uploaded
    const credentialDoc2Uploaded = o.credentialDoc2Uploaded
    const external_id = o.external_id || null
    // let jobPlacementEmployerAddress1 = o.jobPlacementEmployerAddress1
    // let jobPlacementEmployerZipcode = o?.jobPlacementEmployerZipcode?.trim()
    let jobPlacementEmployerCity = o.jobPlacementEmployerCity
    // let jobPlacementEmployerState = o.jobPlacementEmployerState
    debugger
    let internshipEmployer = o.internshipEmployer
    let jobPlacementEmployer = o.jobPlacementEmployer
    let incumbentEmployer = o.incumbentEmployer

    if(jobPlacementEmployerCity?.length>0 && State_City_Zip_Mapper.some(ele=>ele?.city?.toLowerCase()?.trim() == jobPlacementEmployerCity?.toLowerCase()?.trim())){
      jobPlacementEmployerCity = State_City_Zip_Mapper.find(ele=>ele?.city?.toLowerCase()?.trim() == jobPlacementEmployerCity?.toLowerCase()?.trim())?.city
    }
    /* if(jobPlacementEmployer && jobPlacementEmployer.length>0){
      debugger
      const employer = employers.find(e=>e.employer_name === jobPlacementEmployer)
      console.log(`Employer: ${JSON.stringify(employer,undefined,2)}`)
      if(employer){
        if(o?.jobPlacementEmployerState === StateIDs.RI || employer?.state?.toLowerCase() === 'ri'){
          if(employer.zip_code?.length>0){
            let state_city_zip_obj = State_City_Zip_Mapper.find(ele=>ele?.zip?.trim() == employer.zip_code?.trim())
            if(state_city_zip_obj){
              jobPlacementEmployerAddress1 = employer.street
              jobPlacementEmployerCity = state_city_zip_obj.city
              jobPlacementEmployerZipcode = employer.zip_code
            }
          }
          else if(employer.city?.length>0){
            let state_city_zip_obj = State_City_Zip_Mapper.find(ele=>ele?.city?.toLowerCase()?.trim() == employer.city?.toLowerCase()?.trim())
            if(state_city_zip_obj){
              jobPlacementEmployerAddress1 = employer.street
              jobPlacementEmployerCity = state_city_zip_obj.city
              jobPlacementEmployerZipcode = state_city_zip_obj.zip
            }
          }
        }
        else{
          jobPlacementEmployerAddress1 = employer.street
          jobPlacementEmployerCity = employer.city
          jobPlacementEmployerZipcode = employer.zip
          jobPlacementEmployerState = employer?.state?.toUpperCase()
        }
      }
    } */
    debugger
    if(['ri','RI'].includes(o.jobPlacementEmployerState?.toString()) || o.jobPlacementEmployerState?.toString()?.toLowerCase() == 'ri'){
      const state_city_zip_obj = State_City_Zip_Mapper.find(ele=>ele?.zip?.trim() == o.jobPlacementEmployerZipcode?.trim() && ele?.city?.toLowerCase()?.trim() == o.jobPlacementEmployerCity?.toLowerCase()?.trim())
      if(!state_city_zip_obj){
        State_City_Zip_Mapper.push({
          city:o.jobPlacementEmployerCity,
          state: o.jobPlacementEmployerState?.toString(),
          zip: o.jobPlacementEmployerZipcode
        })
      }
    }
		return {
			...o,
			jobPlacementIndustry,
			internshipIndustry,
			internshipOccupation,
			credentialType,
      credentialType2,
      credentialDoc1Uploaded,
      credentialDoc2Uploaded,
			wblType,
			academicCredit,
      external_id,
      jobPlacementEmployerCity,
      internshipEmployer,
      jobPlacementEmployer,
      incumbentEmployer,
		}
	}

	const onParticipantUpdate = async (updatedParticipantData: ParticipantOutcome) => {
    if(['ri','RI'].includes(updatedParticipantData.jobPlacementEmployerState?.toString()) || updatedParticipantData.jobPlacementEmployerState?.toString()?.toLowerCase() == 'ri'){
      debugger
      const state_city_zip_obj = State_City_Zip_Mapper.find(ele=>ele?.zip?.trim() == updatedParticipantData.jobPlacementEmployerZipcode?.trim() && ele?.city?.toLowerCase()?.trim() == updatedParticipantData.jobPlacementEmployerCity?.toLowerCase()?.trim())
      if(!state_city_zip_obj){
        State_City_Zip_Mapper.push({
          city:updatedParticipantData.jobPlacementEmployerCity,
          state: updatedParticipantData.jobPlacementEmployerState?.toString(),
          zip: updatedParticipantData.jobPlacementEmployerZipcode
        })
      }
    }
    debugger

    // const inputs = document.querySelectorAll('input');
    // if (inputs.length > 0) {
    //   inputs[inputs.length - 1].focus();
    // }
		setLoadingData(true)
    let credentialDoc1: any = null
    let credentialDoc2:any = null
    if(participant){
      const payload: any = {
        UserMatch:{
          SiteCode: props.siteCode,
          DateOfBirth: moment(participant.dateOfBirth).format('YYYY-MM-DDT00:00:00'),
          ZipCode: participant.zip,
          FirstName: participant.firstName,
          LastName: participant.lastName,
          SSN: "",
          Gender: participant.gender === 'FEMALE' ? '0' : participant.gender === 'MALE' ? '1' : '9',
        },
        AddlOptions: { UsePseudoSsn: 1  },
        FileAttachmentList:[
          {
            FileName: "",
            FileExt: "",
            FileContents: "",
            DocumentCategory: 4,
            DocumentClass: "",
            DocumentTag: ""
          }
        ],
        UIRegistration: {
          Address1: participant.address1,
          City: participant.city,
          StateAbbr: participant.state
        },
      }
      if(props.credentialDoc1){
        const file = props.credentialDoc1
        payload.FileAttachmentList[0].FileContents=file
        payload.FileAttachmentList[0].FileName = props.credentialDoc1FileName
        payload.FileAttachmentList[0].FileExt = props.credentialDoc1FileExt
        console.debug(`credentialDoc1 = ${JSON.stringify(payload,undefined,2)}`)
        // credentialDoc1 = encryptPayload(payload,props.pk)
        credentialDoc1 = {
          FileContents:file,
          FileName: props.credentialDoc1FileName,
          FileExt: props.credentialDoc1FileExt
        }
      }
      if(props.credentialDoc2){
        const file = props.credentialDoc2
        payload.FileAttachmentList[0].FileContents=file
        payload.FileAttachmentList[0].FileName = props.credentialDoc2FileName
        payload.FileAttachmentList[0].FileExt = props.credentialDoc2FileExt
        console.debug(`credentialDoc2 = ${JSON.stringify(payload,undefined,2)}`)

        // credentialDoc2 = encryptPayload(payload,props.pk)
        credentialDoc2 = {
          FileContents:file,
          FileName: props.credentialDoc2FileName,
          FileExt: props.credentialDoc2FileExt
        }
      }
    }
    console.debug(`credentialDoc1 = ${JSON.stringify(credentialDoc1,undefined,2)}`)
    console.debug(`credentialDoc2 = ${JSON.stringify(credentialDoc2,undefined,2)}`)
    const updatedParticipant = {
      ...updatedParticipantData,
      credential1: props.credential1 || null,
      credential2:props.credential2 || null,
      credentialType: props.credentialType || null,
      credentialType2: props.credentialType2 || null ,
      dateCredentialAttained1: props.dateCredentialAttained1 || null,
      dateCredentialAttained2: props.dateCredentialAttained2 || null,
      credentialDoc1,
      credentialDoc2,
      siteCode: props.siteCode,
      internshipEmployer: updatedParticipantData.internshipEmployer,
      jobPlacementEmployer: updatedParticipantData.jobPlacementEmployer,
      incumbentEmployer: updatedParticipantData.incumbentEmployer,
    }

    try{
      const updateOutcomeResponse = await updateParticipantOutcomes(activityID, participantID, updatedParticipant)
      errors = []
      props.resetState()
      if(updatedParticipant.credentialDoc1 || updatedParticipant.credentialDoc2){
        // Credential 1 Document Upload
        try{
          const cred1UploadRes = await uploadDocument(activityID,participantID,{...updatedParticipant})
          if(cred1UploadRes?.errors?.length>0 ){
            // setTimeout(()=>{
            //   props.genericAction({credential1Error:"Error in uploading credential 1 to EmployRI."})
            // },100)
            errors = cred1UploadRes.errors
          }
        }
        catch(err:any){
           /* setTimeout(()=>{
            props.genericAction({credential1Error:"Error in uploading credential 1 to EmployRI."})
          },100)
          errors.push("Error in uploading credential 1 to EmployRI.")  */
          if(err?.response?.status && err.response.status != 504 ){
            errors.push("Something went wrong")
          }
        }
      }

       /*if(updatedParticipant.credentialDoc2){
        // Credential 2 Document Upload

        try{
          const cred2UploadRes = await uploadDocument(activityID,participantID,{...updatedParticipant,credentialDoc1:null})
          if(cred2UploadRes?.errors?.length>0 ){
            /* setTimeout(()=>{
              props.genericAction({credential2Error:"Error in uploading credential 2 to EmployRI."})
            },100)
            errors.push("Error in uploading credential 2 to EmployRI.")
          }
        }
        catch(err){
          setTimeout(()=>{
            props.genericAction({credential2Error:"Error in uploading credential 2 to EmployRI."})
          },100)
          errors.push("Error in uploading credential 2 to EmployRI.") 
        }
      } */

      try{
        const updatedOutcomes: ParticipantOutcome = await getParticipantOutcomes(activityID, participantID)
        setOutcomes(getInitialOutcomes(updatedOutcomes))
        setOutcomesCopy(getInitialOutcomes(updatedOutcomes))
        setStateProperties(updatedOutcomes)
        if(errors.length>0){
          const errorStr = "Credentials Upload Errors:\n" + errors.join("\n")
          setTimeout(() => {
            handleApiResponse('error',true,errorStr)
          },2000)
        }
        setTimeout(() => {
          handleApiResponse('success', true)
        }, 100)
      }
      catch(err){
        console.log(err)
          handleApiResponse('error', true)
      }
    }
    catch(error){
      handleApiResponse('error', true)
    }


      // if(props.credentialDoc){
      //   if(props.pk){
      //     uploadCredentialDocToEmployRI()
      //   }
      //   else{
      //     // TODO: Handle PK not present
      //   }
        
      // }
	}


	function handleClose(event?: React.SyntheticEvent, reason?: string) {
		if (reason === 'clickaway') {
			return
		}

		setSnackbar({ ...snackbar, open: false })
	}

  const onLocalOutcomesUpdate = (outcomes: any) =>{
    console.log(`onLocalOutcomesUpdate ${outcomes.jobPlacementEmployerAddress1}`)
    setOutcomes((prevOutcome)=>{
      return {...prevOutcome, ...outcomes}
    })
  }
  console.log(`ParticipantOutcomeLanding rendered`)
	return (
		<div className={classes.root}>
			<DefaultLoaderModal loading={loadingData} />
			<Fade in={!loading} timeout={{ enter: 1000 }}>
				<Paper elevation={2} style={{ padding: '16px' }}>


					{
						<Typography variant="h5" component="h1">
							{currentActivity && currentActivity!['name']}
						</Typography>
					}

					{participantName && (
						<Typography variant="h4" component="h2">
							{participantName}
						</Typography>
					)}
					{outcomes && currentActivity && (
						<Grid container={true} spacing={8} justify="center">
							<Grid item={true} xs={12} lg={10} xl={8}>
								{
									ParticipantOutcomeFormPicker(outcomes, onParticipantUpdate, employers,onLocalOutcomesUpdate,outcomesCopy, currentActivity )
								}
							</Grid>
						</Grid>
					)}
				</Paper>
			</Fade>
			<Snackbar
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				open={snackbar.open}
				autoHideDuration={8000}
				ContentProps={{
					'aria-describedby': 'message-id',
				}}
				onClose={handleClose}
			>
				<SnackbarContent
					className={classes[snackbar.type]}
					aria-describedby="client-snackbar"
					message={
						<span id="client-snackbar" className={classes.message}>
							{snackbar.message}
						</span>
					}
				/>
			</Snackbar>
		</div>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		root: {},
		progress: {
			position: 'absolute',
			top: '50%',
			left: '50%',
			marginTop: '-20px',
			marginLeft: '-20px',
		},
		success: {
			backgroundColor: green[600],
		},
		error: {
			backgroundColor: theme.palette.error.dark,
		},
		message: {
			display: 'flex',
			alignItems: 'center',
			backgroundColor: 'transparent',
		},
		forms: {
			display: 'flex',
			justifyContent: 'center',
		},
		formWrapper: {
			flexBasis: '65%',

			[theme.breakpoints.down('md')]: {
				flexBasis: '95%',
			},
		},
	})

export default connector(withStyles(styles)(ParticipantOutcomesLanding))
